import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ExerciceInfos } from '../../model/exercice.model';
import { Formation } from '../../model/formation.model';
import { FormationService } from '../../service/formation.service';

import { ToHourMinutePipe } from '../../pipe/to-hour-minute.pipe';

@Component({
  selector: 'lib-exercices-info-teacher-gauge',
  templateUrl: './exercices-info-teacher-gauge.component.html',
  styleUrl: './exercices-info-teacher-gauge.component.scss',
  standalone: false,
  providers: [],
})
export class ExercicesInfoTeacherGaugeComponent implements OnInit {
    @Input() formation: Formation;
    exercisesInfo: ExerciceInfos;
  
    totalHours: number = 0;
    plannedPercentage: number = 0;
    usedPercentage: number = 0;
    remainingExercises: number = 0;
    hoursDone: number = 0;
  
    constructor(
      private router: Router,
      private formationService: FormationService,
    ) { }
  
    ngOnInit() {
      this.formationService.getFormationExercicesInfo(this.formation.id).subscribe((data) => {
        this.exercisesInfo = data;
        this.updateProgressValues();
      });
    }
  
    updateProgressValues(): void {
      if (this.exercisesInfo) {
        this.totalHours = this.exercisesInfo.total_hours_to_do || 0;
        this.hoursDone = (this.exercisesInfo?.off_site?.duration) + (this.exercisesInfo?.on_site_assigned?.duration);
        this.usedPercentage = this.totalHours > 0 ? ((this.hoursDone / 60) / this.totalHours) * 100 : 0;
      }
    }
  
}
